<template>
  <div class="main main-tabbar">
    <template v-if="mode == 'mobile'">
      <!-- 手机模式 -->
      <div class="banner-background-wrap">
        <div class="banner-bg"></div>
        <!-- <div class="banner-bg-mask"></div> -->
        <div class="banner-cover">
          <img src="http://res.uuudian.com/hk_data/332d592a-0cb1-486c-9ca0-3de2debaa2fb" alt />
        </div>
      </div>

      <div class="top-wrap">
        <!--搜索栏-->
        <Searchbar class="searchbar" :logo="user.mchLogoUrl" />
        <!--大图-->
        <Banner
          class="banners"
          :banners="banners"
          v-show="banners.length > 0"
          @slideChangeTransitionEnd="handleChangeCoverColor"
        />
        <!--热门图标-->
        <HotIcon :items="hotIcons" v-show="hotIcons.length > 0" :reddot="showRedDot" />
      </div>

      <!--精选推荐-->
      <template v-if="productRecommend.length > 0">
        <Title :text="'精选推荐'" />
        <div class="product-list">
          <ProductItem
            v-for="p in productRecommend"
            :key="'r-'+p.productId"
            :type="'small'"
            :product="p"
          />
        </div>
      </template>

      <!--热门商品-->
      <template v-if="productHot.length > 0">
        <Title :text="'热门商品'" />
        <ListView :on-infinite="onHotProductLoadMore" :hasMore="hotProductHasMore">
          <div class="product-list">
            <ProductItem
              v-for="p in productHot"
              :key="'h-'+p.productId"
              :type="'normal'"
              :product="p"
            />
          </div>
        </ListView>
      </template>
      <TabBar active="index"></TabBar>
    </template>
    <template v-if="mode == 'landscape'">
      <!-- 横屏模式，提供给八达等场地显示屏使用 -->
      <div class="big-action-item-list">
        <div
          class="big-action-item"
          v-for="(n,index) in hotIcons"
          :key="n.img"
          v-if="index < (16 - 4)"
          @click="goto(n.link)"
        >
          <Icon class="big-action-item-icon" :img="n.img" size="contain" />
          <div class="big-action-item-text">{{n.text}}</div>
        </div>

        <div class="big-action-item" @click="goto('/pages/products/Categorys')">
          <Icon
            class="big-action-item-icon"
            :img="require('../../assets/icon-hoticon-cates.png')"
            size="contain"
          />
          <div class="big-action-item-text">全部分类</div>
        </div>

        <div class="big-action-item" @click="goto('/pages/products/List?affordable=1')">
          <Icon
            class="big-action-item-icon"
            :img="require('../../assets/icon-afforable-action.png')"
            size="contain"
          />
          <div class="big-action-item-text">我能兑换</div>
        </div>

        <div class="big-action-item" @click="goto('/pages/orders/Cart')">
          <Icon
            class="big-action-item-icon"
            :img="require('../../assets/icon-cart-action.png')"
            size="contain"
          />
          <div class="big-action-item-text">购物车</div>
        </div>

        <div class="big-action-item" @click="goto('/pages/setting/Index')">
          <Icon
            class="big-action-item-icon"
            :img="require('../../assets/icon-me-action.png')"
            size="contain"
          />
          <div class="big-action-item-text">个人中心</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Searchbar from "@/components/homepage/Searchbar";
import Banner from "@/components/homepage/Banner";
import HotIcon from "@/components/homepage/HotIcon";
import Title from "@/components/homepage/Title";
import api from "../../api";
var wx = require("weixin-js-sdk");
import $ from "jquery";

export default {
  title: "礼品商城",
  keepAlive: false,
  components: { Searchbar, Banner, HotIcon, Title },
  data() {
    return {
      tags: "true",
      mode: "mobile", //显示类型：mobile 手机， landscape 横屏
      user: api.store.loginedUser,
      showRedDot: null,
      banners: [
        // {img: '',link:''}
      ],
      hotIcons: [
        // {img: 'http://res.uuudian.com/hk_data/3e98966a-ae44-425e-902b-825bce346351', text: '电子数码', link: '点击跳转路径'},
      ],
      productRecommend: [
        // {productId: 0, name: '越南进口 中原G7三合一速溶咖啡1600g', price: 1200, img:'https://m.360buyimg.com/babel/s422x422_jfs/t2932/279/759495863/243388/5086177e/57677d33Ned8dbfd5.jpg'},
      ],
      productHot: [
        // {productId: 0, gainCount: 10, name: '越南进口 中原G7三合一速溶咖啡1600g', price: 1200, img:'https://m.360buyimg.com/babel/s422x422_jfs/t2932/279/759495863/243388/5086177e/57677d33Ned8dbfd5.jpg'},
      ],
      hotProductHasMore: true,
      hotProductLastId: "",
      colorList: []
    };
  },
  methods: {
    handleChangeCoverColor(index) {
      // var $mask = $('.banner-bg-mask');
      // $mask.removeClass('xhide');

      setTimeout(() => {
        this.renderCover(index);
      }, 100);
    },
    renderCover(index) {
      var sc = this.colorList[index]["sc"];
      var ec = this.colorList[index]["ec"];

      // var $mask = $('.banner-bg-mask');
      // $mask.addClass('xhide');  

      var $cover = $(".banner-bg");
      if (sc && !ec) {
        $cover.css({
          background: `${sc}`
        });
        $cover.css({
          background: `${sc}`
        });
      } else {
        $cover.css({
          background: `linear-gradient(${sc}, ${ec})`,
        });
        $cover.css({
          background: `linear-gradient(${sc}, ${ec})`,
        });
      }
    },
    loadHotProductData(done) {
      if (!done) {
        done = () => {};
      }
      //热门商品
      api.homepage.getHotProductList(
        this.hotProductLastId,
        10,
        data => {
          console.log(data);
          this.hotProductLastId = data.lastId;
          this.hotProductHasMore = data.hasMore;

          data.list.forEach(i => {
            this.productHot.push({
              productId: i.skuId,
              gainCount: i.soldCount,
              title: i.title,
              name: i.name,
              price: i.price,
              img: i.image
            });
          });
          done();
        },
        r => {
          this.$alertDialog(r.msg);
          this.$hideLoading();
          done();
        }
      );
    },
    onHotProductLoadMore(done) {
      this.loadHotProductData(done);
    },
    goto(link) {
      if (link.startsWith("http")) {
        window.location.href = link;
      } else {
        this.$routerPush(this, link);
      }
    }
  },
  mounted() {
    //恢复
    api.pagestate.recover(this, () => {
      console.log("init data");
      //大图
      api.homepage.getBannerList(data => {
        data.list.forEach(i => {
          var obj = {};
          obj["sc"] = i.backgroundColorStart;
          obj["ec"] = i.backgroundColorEnd;
          this.colorList.push(obj);

          this.banners.push({
            id: i.id,
            img: i.image,
            link: i.link
          });
        });

        setTimeout(() => {
          this.renderCover(0);
        }, 100);
      });
      //图标
      api.homepage.getHotIconList(data => {
        data.list.forEach(i => {
          this.hotIcons.push({
            id: i.id,
            img: i.image,
            text: i.name,
            link: i.link
          });
        });
      });
      //推荐商品
      api.homepage.getRecommendProductList(data => {
        console.log(data);
        data.list.forEach(i => {
          this.productRecommend.push({
            productId: i.skuId,
            gainCount: i.soldCount,
            name: i.name,
            title: i.title,
            price: i.price,
            img: i.image
          });
        });
      });

      this.loadHotProductData();
    });

    //获取当前的Page，初始化分享参数
    wx.ready(() => {
      console.log("wx ready");
      // 微信分享的数据
      var shareData = {
        imgUrl: this.user.mchLogoUrl, // 分享显示的缩略图地址
        link: location.href, // 分享地址
        desc: "众多好礼等你来取", // 分享描述
        title: "好酷礼品商城", // 分享标题
        success: function() {
          // 分享成功可以做相应的数据处理
          //alert("分享成功"); }
        }
      };
      wx.onMenuShareTimeline(shareData);
      wx.onMenuShareAppMessage(shareData);
    });

    //根据窗口大小来适配页面，主要为八达场地机器适配，分辨率 1080 x 1220
    var winWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    var winHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    console.log(`屏幕分辨率:${winWidth}x${winHeight}`);
    var winScale = winHeight / winWidth;
    var minLandscapeScale = 1100 / 1080;
    var maxLandscapeScale = 1300 / 1080;

    if (winScale > minLandscapeScale && winScale < maxLandscapeScale) {
      //如果分辨率在范围内，则设置为landscape
      this.mode = "landscape";
    }
  }
};
</script>

<style scoped lang="less">
.banner-bg{
  width: 100vw;
  height: 45vw;
  position: absolute;
  top: 0;
  left: 0;
}
.banner-bg-mask{
  width: 100vw;
  height: 45vw;
  position: absolute;
  top: 0;
  left: 0;
  transition: all .5s ease;
  background:#fff;
  opacity: 1;

  &.xhide{
    opacity: 0;
  }

}
.banner-cover {
  position: absolute;
  z-index: 1;
  top: 39vw;
  left: 0;
  img {
    width: 100vw;
  }
}
.top-wrap {
  position: relative;
  z-index: 1;
}
.banners {
  width: 90vw;
  margin: 0 auto;
  border-radius: 2.5vw;
  overflow: hidden;
}

.product-list {
  text-align: center;
}

.big-action-item-list {
  font-size: 0;

  @itemHeight: 1220vw / 4 / 1080 * 100;

  .big-action-item {
    display: inline-block;
    width: 100vw / 4;
    height: @itemHeight;
    outline: 1px solid #dddddd;
    .big-action-item-icon {
      width: 14vw;
      height: 14vw;
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-top: (@itemHeight - 14vw - 2.96vw - 2.4vw) / 2;
    }
    .big-action-item-text {
      font-size: 2.96vw;
      color: #313131;
      text-align: center;
      margin-top: 2.4vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homepage/Index.vue